import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";
import { ArrowUpRight } from "lucide-react";
import { useBusiness } from "../context/BusinessContext";
import axios from "axios";
const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function Home() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const { business } = useBusiness();

useEffect(() => {
  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/products`);
      setProducts(res.data.items || []);
    } catch (err) {
      console.error("Fetch error:", err);
      setProducts([]);
    }
  };

  fetchProducts();
}, []);

  return (
    <div data-testid="home-page">   
      {/* Hero */}
      <section className="border-b border-neutral-900/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-28 grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7 fade-up">
            <div className="text-xs uppercase tracking-ultra text-neutral-500 mb-6">
              Spring Collection — 2026
            </div>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tighter leading-[0.9]">
              Objects of
              <br />
              <span className="font-display italic font-light">quiet intention.</span>
            </h1>
            <p className="mt-8 max-w-lg text-neutral-700 leading-relaxed">
              {business.tagline || "A curated edit of modern essentials made to last. Restrained. Honest. Built around the way we actually live."}
            </p>
            <div className="mt-10 flex gap-4">
              <Link
                to="/shop"
                className="bg-black text-white px-8 py-4 text-xs uppercase tracking-ultra font-bold hover:bg-neutral-800 transition-colors inline-flex items-center gap-2"
                data-testid="hero-shop-button"
              >
                Shop the edit <ArrowUpRight className="w-4 h-4" />
              </Link>
              <Link
                to="/shop?featured=true"
                className="border border-black px-8 py-4 text-xs uppercase tracking-ultra font-bold hover:bg-black hover:text-white transition-colors"
                data-testid="hero-featured-button"
              >
                Featured
              </Link>
            </div>
          </div>
          <div className="md:col-span-5">
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1491553895911-0055eca6402d?auto=format&fit=crop&q=80&w=1200"
                alt="Hero"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Marquee */}
      <section className="py-6 border-b border-neutral-900/10 overflow-hidden">
        <div className="marquee text-[11px] uppercase tracking-ultra font-bold">
          <div className="marquee-track">
            {Array(2)
              .fill(0)
              .map((_, i) => (
                <div key={i} className="flex gap-12 items-center">
                  <span>Free shipping over {business.currency || "MYR"} 250</span>
                  <span>◆</span>
                  <span>Billplz • Stripe • QR Pay accepted</span>
                  <span>◆</span>
                  <span>Crafted in small batches</span>
                  <span>◆</span>
                  <span>Worldwide delivery</span>
                  <span>◆</span>
                  <span>Ethically sourced materials</span>
                  <span>◆</span>
                </div>
              ))}
          </div>
        </div>
      </section>

      {/* Categories bento */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="flex items-end justify-between mb-12">
          <h2 className="text-4xl md:text-5xl font-black tracking-tighter leading-none">
            Categories
          </h2>
          <Link to="/shop" className="text-xs uppercase tracking-ultra border-b border-black pb-1" data-testid="home-view-all-link">
            View all →
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {categories.map((c, idx) => (
            <Link
              key={c.id}
              to={`/shop?category_id=${c.id}`}
              className={`group block relative overflow-hidden ${idx === 0 ? "md:col-span-1 md:row-span-2" : ""}`}
              data-testid={`home-category-${c.slug}`}
            >
              <div className={`${idx === 0 ? "aspect-[3/4]" : "aspect-[4/3]"} overflow-hidden bg-neutral-200`}>
                <img
                  src={c.image}
                  alt={c.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/70 to-transparent">
                <div className="text-[10px] uppercase tracking-ultra text-white/80">
                  Collection
                </div>
                <div className="text-2xl font-black text-white tracking-tighter">
                  {c.name}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Featured products */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="flex items-end justify-between mb-12">
          <div>
            <div className="text-xs uppercase tracking-ultra text-neutral-500 mb-2">Selected</div>
            <h2 className="text-4xl md:text-5xl font-black tracking-tighter leading-none">
              Featured pieces
            </h2>
          </div>
          <Link
            to="/shop"
            className="hidden md:inline text-xs uppercase tracking-ultra border-b border-black pb-1"
            data-testid="home-view-shop-link"
          >
            See all →
          </Link>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {products && products.length > 0 ? (
            products.map((p) => (
            <ProductCard key={p.id} product={p} />
            ))
            ) : (
             <p>No products found</p>
            )}
        </div>
      </section>
    </div>
  );
}
